/**
 * Vignette d'un produit (retour Enzo 23 juil) : la PHOTO d'abord — elle parle
 * bien plus vite qu'un emoji — et l'emoji de la categorie sert de REPLI tant
 * qu'aucune photo n'existe. Utilisee dans tous les ecrans producteur Paniers
 * (dispos, feuille de selection, demande, preparation, Mes offres).
 */
function VisuelProduit({ photo, emoji, taille = 44, sombre = false }) {
  const commun = {
    width: taille,
    height: taille,
    borderRadius: Math.round(taille * 0.32),
    flexShrink: 0,
  }
  if (photo) {
    return (
      <img
        src={photo}
        alt=""
        loading="lazy"
        style={{ ...commun, objectFit: 'cover', background: 'rgba(7,62,61,0.06)' }}
      />
    )
  }
  return (
    <span
      className="flex items-center justify-center"
      style={{
        ...commun,
        fontSize: Math.round(taille * 0.5),
        background: sombre ? 'rgba(255,255,255,0.08)' : 'rgba(7,62,61,0.06)',
        border: sombre ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(7,62,61,0.07)',
      }}
    >
      {emoji || '🧺'}
    </span>
  )
}

export default VisuelProduit
